






























import { Component, Prop, Vue } from 'vue-property-decorator'
import Guests, { GuestState } from '@/services/Guests'
import { getUserId } from '@/firebaseApp'

@Component
export default class PrivateVideoStream extends Vue {
  @Prop({ required: true }) public state!: GuestState
  @Prop({ required: true }) public watchingVideoId!: string

  public isPlaying: boolean = false

  public mounted() {
    this.isPlaying = false
  }

  updated() {
    if (this.isPlaying && !this.isShown) {
      this.isPlaying = false
    }
  }

  get isShown() {
    return this.watchingVideoId && this.state === GuestState.WatchingVideo
  }

  public async finishedVideo() {
    const restaurantId = this.$route.params.restaurantId
    const accessCode = this.$route.params.accessCode
    const userId = await getUserId()

    await Guests.setWatchingVideoId(restaurantId, accessCode, userId, null)
  }

  public setVolume() {
    this.isPlaying = true
    const youTubeRef = this.$refs.youtube as any
    const youTubePlayer = youTubeRef?.player
    if (youTubePlayer) {
      youTubePlayer.setVolume(100)
    }
  }

  // When autoplay is not supported,
  // the user should have an option to start the video
  public startVideo() {
    if (!this.isPlaying) {
      const youTubeRef = this.$refs.youtube as any
      const youTubePlayer = youTubeRef?.player
      youTubePlayer.playVideo()
    }
  }
}
